import { defineStore } from "pinia";
import { ref, computed } from "vue";
import type { UserDto } from "@buflow/contracts";
import { authApi } from "../api/auth";
import { ApiError } from "../api/client";

export const useAuthStore = defineStore("auth", () => {
  const user = ref<UserDto | null>(null);
  const loading = ref(false);
  const error = ref<string | null>(null);

  const isAuthenticated = computed(() => user.value !== null);
  const isAdmin = computed(() => user.value?.role === "admin");

  async function login(username: string, password: string): Promise<boolean> {
    loading.value = true;
    error.value = null;
    try {
      const result = await authApi.login(username, password);
      user.value = result.user;
      return true;
    } catch (e) {
      if (e instanceof ApiError) {
        error.value = e.message;
      } else {
        error.value = "登录失败，请稍后重试";
      }
      return false;
    } finally {
      loading.value = false;
    }
  }

  async function logout(): Promise<void> {
    try {
      await authApi.logout();
    } finally {
      user.value = null;
    }
  }

  async function fetchSession(): Promise<boolean> {
    try {
      const result = await authApi.getSession();
      user.value = result.user;
      return true;
    } catch {
      user.value = null;
      return false;
    }
  }

  function clearError(): void {
    error.value = null;
  }

  return {
    user,
    loading,
    error,
    isAuthenticated,
    isAdmin,
    login,
    logout,
    fetchSession,
    clearError,
  };
});
